module.exports = __webpack_public_path__ + "img/address-school.0418d858.svg";